import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { STREAM_PLAY_LIVE_CONFIG_TOKEN } from '../stream-play-tokens';

export interface StreamPlayLiveConfiguration {
  checkStartDate?: boolean,
  checkEndDate?: boolean,
  offset?: number
}


@NgModule({
  imports: [CommonModule],
})
export class StreamPlayLiveModule {
  static forRoot(config: StreamPlayLiveConfiguration): ModuleWithProviders<StreamPlayLiveModule> {
    return {
      ngModule: StreamPlayLiveModule,
      providers: [
        {
          provide: STREAM_PLAY_LIVE_CONFIG_TOKEN,
          useValue: config,
        },
      ],
    };
  }
}
